<template>
  <div ref="editor" class="editor">
    <div class="editor-words__limit">{{ text.length }}/10000</div>
  </div>
</template>
<script>
import { getEditorContent, UPLOAD_IMG_TIMEOUT } from '@/common/editor/config';
export default {
  name: 'Editor',
  data() {
    return {
      // 编辑器对象
      editor: null,
      // 编辑器工具栏是否吸顶
      toolsFixed: false,
      // 编辑器内的文本内容
      text: '',
      // 编辑器内是否有内容
      haveContent: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initEditor();
    });
  },
  methods: {
    /**
     * 初始化编辑器
     */
    initEditor() {
      const editor = new window.wangEditor(this.$refs.editor);
      editor.customConfig = {
        // 默认提示语
        placeholder: '请描述一下你的爱车特点（5-10000字）',
        // 是否只粘贴文本
        onlytxt: true,
        // 自动保存草稿
        autoLoadDraft: false,
        // 草稿的键名
        draftKey: '',
        // 上传文件最大限制
        uploadImgMaxSize: 15 * 1024 * 1024,
        // 上传文件的超时时间
        uploadImgTimeout: UPLOAD_IMG_TIMEOUT,
        // 本地存储
        localSave: false,
        // 一次性上传文件的最大数量
        uploadImgMaxLength: 9,
        // 图片上传接口
        uploadImgServer: '/media/v1/upload',
        // 图片本地化接口
        uploadImgLocal: '/media/v1/localize',
        imgHostWhiteList: ['media.canada-cn.net'],
        menus: [],
        // 内容变化时
        change: () => {
          const { html, text, imageList, videoList, audioList, haveContent } = getEditorContent(editor);

          this.text = text;
          this.haveContent = haveContent;

          this.$emit('change', { editor, html, text, imageList, videoList, audioList, haveContent });
        },
      };
      editor.create();
      this.editor = editor;

      // 编辑器初始化完成
      this.$emit('ready', this.editor);
    },
  },
};
</script>
<style lang="scss" scoped>
.editor {
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  position: relative;
  &:hover {
    border-color: var(--text-color-9);
  }
  ::v-deep {
    .editor-toolbar {
      display: none;
    }
    .edite-ement {
      z-index: 1;
      .editor-txt-content {
        min-height: 144px;
        height: auto;
      }
      .placeholder {
        top: 12px;
      }
    }
  }
}
.editor-words__limit {
  position: absolute;
  right: 15px;
  bottom: 15px;
  z-index: 1;
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-6);
}
</style>
